// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"802ad5cb","701":"12a20cdc","783":"eae82308","825":"d03f0a07"}[chunkId] + ".chunk.css";
};